import { useMasterData } from "@/stores/master-data";
import { mapGenericToManageableHighlight } from "@/utils/mixed-highlights";
import { HighlightsKey, MixedHighlightValue } from "@/types/Highlights";
import { CustomHighlights } from "@/types/generated/ExperienceRawServiceApi";
import { premadeApiKeys } from "@/features/experience-highlights/lib/get-all-premade-highlights";

export function mapDataToHighlights(
  highlightType: HighlightsKey,
  premadeData: string[] = [],
  customsData: CustomHighlights[] = []
): MixedHighlightValue {
  const masterData = useMasterData();
  const mappingKey = premadeApiKeys[highlightType].store;
  return {
    premade: premadeData?.map((code: string) => masterData.getHighlightByCode(mappingKey, code)),
    custom: mapGenericToManageableHighlight(customsData),
  };
}
